import type { SortableListDataProviderProps } from "../Provider";
import { DndContext, SortableListDataProvider } from "../Provider";

export interface ContainerProps extends SortableListDataProviderProps {
  children: React.ReactNode;
  restrictToParentElement?: boolean;
  shouldUseKeyboardSensor?: boolean;
}

export const Container = ({
  children,
  shouldUseKeyboardSensor = true,
  ...rest
}: ContainerProps) => (
  <SortableListDataProvider {...rest}>
    <DndContext shouldUseKeyboardSensor={shouldUseKeyboardSensor}>
      {children}
    </DndContext>
  </SortableListDataProvider>
);
